import type { RootState } from 'store';

export const selectActiveForm = (state: RootState) => state.activeForm.current;
